import request from '@/utils/http'

export function login(data) {
  return request({
    url: 'passport.account.sign-in',
    method: 'post',
    data
  })
}

export function regist(data) {
  return request({
    url: 'passport.account.regist',
    method: 'post',
    data
  })
}

export function searchUser(data) {
  return request({
    url: 'user.search',
    method: 'get',
    params: data,
    auth: true
  })
}

export function userPost(data) {
  return request({
    url: 'user.account.post',
    method: 'post',
    data,
    auth: true
  })
}

export function getInfo(data) {
  return request({
    url: 'user.get',
    method: 'get',
    params: data,
    auth: true
  })
}

export function deleteUserAccount(data) {
  return request({
    url: 'user.account.delete',
    method: 'post',
    data,
    auth: true
  })
}

export function ForbiddenPost(data) {
  return request({
    url: 'user.forbidden',
    method: 'post',
    data,
    auth: true
  })
}

export function logout() {
  return request({
    url: 'passport.sign-out',
    method: 'post',
    auth: true
  })
}

export function renewExpire() {
  return request({
    url: 'passport.renew',
    method: 'get',
    auth: true
  })
}

export function BaseInfoPost(data) {
  return request({
    url: 'user.base-info.post',
    method: 'post',
    data,
    auth: true
  })
}

